import { makeStyles } from "@material-ui/core";
import { fontSize } from "./fonts";

export const useExaminationStyles = makeStyles((theme) => ({
  gridList: {
    overflowY: "auto",
    padding: 0,
  },
  listItem: {
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
  },
  gridListContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  subtitle: {
    color: "black",
  },
  title: {
    [theme.breakpoints.down("sm")]: {
      fontSize: fontSize.h3,
    },
  },
  patient: {
    width: "250px",
    height: "380px",
  },
  examSearchfield: {
    backgroundColor: "white",
    width: "100%",
    marginTop: 10,
    borderRadius: "60%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: `0px solid white`,
        zIndex: 7,
      },
    },
  },
  searchDiv: {
    width: "90%",
  },
  searchfield: {
    marginTop: 10,
    backgroundColor: "white",
    borderRadius: "60%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: `0px solid white`,
        zIndex: 7,
      },
    },
  },
  searchinput: {
    backgroundColor: "white",
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  iconsContainer: {
    position: "absolute",
    color: "white",
    width: "250px",
    height: "380px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  searchicon: {
    background: "#479BD0",
    height: "30px",
    border: "none",
    width: "30px",
    borderRadius: "50%",
    position: "absolute",
    opacity: "0.8",
    "&:hover": {
      background: "#b3c8e5",
    },
  },
  chosenicon: {
    background: "#7B0000",
    color: "white",
    height: "30px",
    border: "none",
    width: "30px",
    borderRadius: "50%",
    position: "absolute",
    opacity: "0.8",
    "&:hover": {
      background: "#b3c8e5",
    },
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: "#C4C4C4",
  },
  bodySubContainer: {
    display: "flex",
    flexDirection: "column",
  },
  bodyDiv: {
    overflowY: "auto",
    marginBottom: 10,
    [theme.breakpoints.down("sm")]: {
      "&::-webkit-scrollbar": {
        height: "9px",
        width: "9px",
        borderWidth: "3px",
      },
      "&::-webkit-scrollbar-track-piece": {
        backgroundColor: "#C4C4C4",
        borderRadius: "8px",
        borderColor: "#C4C4C4",
        borderWidth: "1px 5px 1px 5px",
        borderStyle: "solid",
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "9px",
        borderColor: "black",
        backgroundColor: "black",
        borderStyle: "solid",
        borderWidth: "2px 6px 2px 6px",
      },
    },
  },
  magnifierDiv: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "90vw",
  },
  magnifierTitle: {
    marginTop: 0,
    marginLeft: -5,
    textAlign: "left",
    width: "100%",
    fontStyle: "italic",
  },
  searchContainer: {
    marginTop: 30,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      marginBottom: 30,
    },
    alignItems: "center",
    justifyContent: "center",
  },
  vitals: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  generalBlue: {
    textTransform: "none",
    background: "#1D3557",
    color: "#FFFFFF",
    marginLeft: 10,
    marginRight: 10,
  },
  rightGridList: {
    width: "80%",
    display: "flex",
    maxHeight: 450,
    overflowY: "auto",
  },
  accordionStyle: {
    background: "transparent",
    width: "100%",
    padding: 0,
    margin: 0,
  },
  accordionSummary: {
    padding: 0,
    margin: 0,
  },
  mobileHeader: {
    marginTop: 5,
    marginLeft: 5,
    marginBottom: 5,
  },
  vitalSignAns: {
    display: "flex",
    marginTop: 10,
    alignSelf: "flex-start",
    width: "100%",
    paddingLeft: 25,
    paddingRight: 20,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 25,
      paddingRight: 10,
    },
  },
  subSystem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItem: "center",
    width: "100%",
  },
  bodyAndSlider: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  signAns: {
    padding: 15,
    display: "flex",
    alignSelf: "flex-start",
    width: "100%",
  },
  suggestion: {
    color: "#00008B",
    textDecoration: "underline",
    cursor: "pointer",
    marginTop: 5,
    marginBotton: 5,
  },
  suggestionContainer: {
    width: "100%",
    background: "#DCDCDC",
    padding: 20,
    borderRadius: 5,
  },
}));
